export default __webpack_public_path__ + "assets/post.cb370e8c.svg";